const ANIMATION_DURATION_MS = 100;

export { ANIMATION_DURATION_MS };
